import {
  QueryCache,
  QueryClient,
  QueryClientProvider,
} from "@tanstack/react-query";
import _ from "lodash";
import React from "react";
import ReactDOM from "react-dom";
import ReactModal from "react-modal";
import { toast } from "react-toastify";
import App from "./components/App";
import "./modules/shared/src/styles/index.scss";
import reportWebVitals from "./reportWebVitals";

const twentyFourHoursInMs = 1000 * 60 * 60 * 24;
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: twentyFourHoursInMs,
    },
  },
  queryCache: new QueryCache({
    onError: (error, query) => {
      if (!_.get(query.meta, "disableDefaultErrorHandler", false)) {
        toast.error(
          _.get(query.meta, "errorMessage", _.get(error, "message", error))
        );
      }
    },
  }),
});

if (process.env.NODE_ENV !== "test") {
  ReactModal.setAppElement("#root");
}

ReactDOM.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
